import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './translate.service';
import { TranslateOptions } from './translate.interface';

/**
 * {{ 'ข้อความไทย' | translate : 'module' }}
 * {{ 'จำนวน {count} ห้อง' | translate : { module: 'module', count: 2 } }}
 *
 * อ่าน signal ของ TranslateService ทำให้ template อัปเดตเองเมื่อเปลี่ยนภาษา
 */
@Pipe({ name: 'translate', pure: false })
export class TranslatePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: string | null | undefined, options?: TranslateOptions): string {
    return this.translate.instant(value, options);
  }
}
